// frontend/src/pages/AboutUsPage.js

import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUsPage.css';

function AboutUsPage() {
  return (
    <div className="about-page-container">
      
      {/* Brand Header */}
      <h1>FullMockup</h1>
      <h2 className="about-subtitle">Bridging the Gap Between Great Design and Reality</h2>

      <p>
        Welcome to <strong>FullMockup</strong>. We are the premier all-in-one solution for 
        Print-on-Demand (POD) entrepreneurs, independent designers, and e-commerce brands 
        who demand excellence. We believe that a great design deserves a presentation that 
        is just as impactful.
      </p>
      
      <p>
        In the fast-paced world of e-commerce, high-quality visuals are the number one 
        driver of sales. But traditional product photography is slow, expensive, and 
        logistically difficult. FullMockup exists to change that. We turn flat digital 
        designs into stunning, photorealistic product photography in seconds—no cameras, 
        no shipping, and no expensive studio time required.
      </p>

      <h3>Our Technology: The V25 Warp Engine</h3>
      <p>
        At the heart of FullMockup is our proprietary <strong>Smart Warp Technology</strong>.
      </p>
      <p>
        Unlike basic tools that simply "paste" a logo on top of a shirt, our engine understands 
        the physics of fabric. It analyzes the depth, lighting, and texture of the garment, 
        ensuring your design folds where the fabric folds and shadows where the light hits.
      </p>
      <p>
        Whether you are designing t-shirts, hoodies, or mugs, our technology ensures your 
        final image looks like it came straight from a professional photo studio, not a 
        computer screen.
      </p>
      
      <h3>Your Privacy, Secured</h3>
      <p>
        We understand that your designs are your intellectual property. Unlike many other 
        tools that send your data to third-party AI processors, FullMockup is built on a 
        <strong> Private, Self-Hosted Infrastructure</strong>.
      </p>
      <ul className="about-list">
        <li>
            <strong>Private Processing:</strong> Your images are processed on our secure servers.
        </li>
        <li>
            <strong>Data Safety:</strong> We do not use your designs to train public AI models.
        </li>
        <li>
            <strong>Transient Storage:</strong> For our free users, we employ automated systems 
            that permanently delete input and output files after 24 hours to ensure your data 
            doesn't sit on a server unnecessarily.
        </li>
      </ul>

      <h3>Our Mission</h3>
      <p>
        Our mission is simple: <strong>To empower the creator economy</strong>.
      </p>
      <p>
        We want to remove the technical and financial barriers that stand between a creative 
        idea and a successful product launch. By automating the visual production process, 
        we give you back your most valuable asset: time. Time to design, time to market, 
        and time to grow your business.
      </p>

      <p>
        Thank you for choosing FullMockup. We can't wait to see what you build.
      </p>

      {/* --- Legal Section --- */}
      <div className="about-legal-section">
        <h3>Company & Legal Information</h3>
        <p>
            Transparency is key to our business. Please review our policies to understand 
            how we operate and protect your rights:
        </p>
        <ul className="legal-links-list">
            <li>
                <Link to="/terms">Terms & Conditions</Link> – Understanding our service agreement.
            </li>
            <li>
                <Link to="/privacy">Privacy Policy</Link> – How we manage and protect your data.
            </li>
            <li>
                <Link to="/refund">Refund & Cancellation Policy</Link> – Details on our digital goods and credit system.
            </li>
        </ul>
      </div>

      {/* --- Contact Section --- */}
      <div className="about-contact-section">
        <h3>Get in Touch</h3>
        <p>
            Have questions about our technology, billing, or just want to say hello? 
            We are here to help.
        </p>
        
        <Link to="/contact-us" className="about-contact-btn">
            Contact Us
        </Link>
      </div>

    </div>
  );
}

export default AboutUsPage;